import { createFileRoute } from '@tanstack/react-router'
import SlidesPage from '@/spa/pages/SlidesPage'
import { routeErrorComponent } from '../_shared/RouteError'

export const Route = createFileRoute('/slides/')({
  component: SlidesPage,
  errorComponent: routeErrorComponent,
})
